export default async function CommonAPISelect(url, payload) {
    console.log("🚀 ~ CommonAPISelect ~ url, payload:", url, payload)
    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        throw new Error(`Request failed: ${res.status}`);
    }
    return res.json();
}